import React, { useEffect, useState } from "react";
import { FiChevronRight, FiPlusCircle } from "react-icons/fi";

import { useAuthentication } from "../../hooks";
import { listCardsRequest } from "../../requests";

import * as Styles from "./styles";

export function MyCardsList({
  onSelect,
  navigateToAddCard,
  msisdn,
  setIsLoading,
}) {
  const { authToken } = useAuthentication({ setIsLoading });
  const [cardsList, setCardsList] = useState();

  useEffect(() => {
    async function getCards() {
      try {
        setIsLoading(true);
        const response = await listCardsRequest({
          msisdn,
          authToken,
        });

        setCardsList(response.data.cardList || []);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    getCards();
  }, [msisdn]);

  return (
    <Styles.MyCardsListContainer>
      <Styles.CardList>
        {!cardsList ? (
          <p>Listando cartões salvos...</p>
        ) : cardsList?.length > 0 ? (
          cardsList?.map((card) => (
            <button onClick={() => onSelect(card)} key={card.paymentID}>
              <img
                src={require(`../../../images/payments/${card.flag.toLowerCase()}.svg`)}
                alt=""
              />
              <div>
                <h2>Cartão {card.flag}</h2>
                <p>Final {card.digFour}</p>
              </div>
              <FiChevronRight size={64} />
            </button>
          ))
        ) : (
          <p>Nenhum cartão cadastrado!</p>
        )}
      </Styles.CardList>
      <Styles.AddCardButton onClick={navigateToAddCard}>
        <FiPlusCircle size={24} /> Adicionar novo cartão
      </Styles.AddCardButton>
    </Styles.MyCardsListContainer>
  );
}
